import { render, staticRenderFns } from "./BrandsReport.vue?vue&type=template&id=18f16b84&scoped=true"
import script from "./BrandsReport.vue?vue&type=script&lang=js"
export * from "./BrandsReport.vue?vue&type=script&lang=js"
import style0 from "./BrandsReport.vue?vue&type=style&index=0&id=18f16b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f16b84",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Fbrands-report%2FBrandsReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports